var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandChildren(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.25C10.5 4.93629 13.1863 2.25 16.5 2.25L18 2.25V3.75L16.5 3.75C14.0147 3.75 12 5.76472 12 8.25V11.25H18V12.75H12V15.75C12 18.2353 14.0147 20.25 16.5 20.25H18V21.75H16.5C13.1863 21.75 10.5 19.0637 10.5 15.75V12.75L6 12.75V11.25L10.5 11.25V8.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 3C22.5 4.65685 21.1569 6 19.5 6C17.8431 6 16.5 4.65685 16.5 3C16.5 1.34315 17.8431 0 19.5 0C21.1569 0 22.5 1.34315 22.5 3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12C22.5 13.6569 21.1569 15 19.5 15C17.8431 15 16.5 13.6569 16.5 12C16.5 10.3431 17.8431 9 19.5 9C21.1569 9 22.5 10.3431 22.5 12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 21C22.5 22.6569 21.1569 24 19.5 24C17.8431 24 16.5 22.6569 16.5 21C16.5 19.3431 17.8431 18 19.5 18C21.1569 18 22.5 19.3431 22.5 21Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12C7.5 13.6569 6.15685 15 4.5 15C2.84315 15 1.5 13.6569 1.5 12C1.5 10.3431 2.84315 9 4.5 9C6.15685 9 7.5 10.3431 7.5 12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandChildren);
export default __webpack_public_path__ + "static/media/expand-children.5c84aae0b325a399cc249c305cf66a5b.svg";
export { ForwardRef as ReactComponent };